// QuestionTexto - Pregunta tipo Texto Libre
// Sprint 3 - Mobile-first design

import React, { useState } from 'react';
import { Box, TextField, Chip, Typography } from '@mui/material';
import { PreguntaCompleta } from '../../../../types/formulario.types';
import { QuestionResponse } from '../../../../types/audit.types';

interface QuestionTextoProps {
  pregunta: PreguntaCompleta;
  respuesta?: QuestionResponse;
  onChange: (valor: any, comentario?: string) => void;
}

const QuestionTexto: React.FC<QuestionTextoProps> = ({
  pregunta,
  respuesta,
  onChange,
}) => {
  const valorActual = (respuesta as any)?.response_value as { texto?: string } | undefined;
  const [texto, setTexto] = useState(valorActual?.texto || '');

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const nuevoTexto = event.target.value;
    setTexto(nuevoTexto);
    onChange({ texto: nuevoTexto });
  };

  const maxLength = pregunta.config_validacion?.max || 500;
  const minLength = pregunta.config_validacion?.min || 0;

  return (
    <Box>
      {/* Header */}
      <Box sx={{ mb: 2.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
          <Box sx={{ fontSize: { xs: '1rem', sm: '1.0625rem' }, fontWeight: 600 }}>
            {(pregunta as any).text}
          </Box>
          {(pregunta as any).required && (
            <Chip label="Obligatoria" size="small" color="error" sx={{ height: 20, fontSize: '0.6875rem' }} />
          )}
        </Box>
        {(pregunta as any).description && (
          <Box sx={{ fontSize: '0.875rem', color: 'text.secondary', fontStyle: 'italic', mt: 0.5 }}>
            {(pregunta as any).description}
          </Box>
        )}
      </Box>

      {/* Sección de respuesta */}
      <Box 
        sx={{ 
          p: 2, 
          bgcolor: 'action.hover', 
          borderRadius: 1,
        }}
      >
        <Typography 
          variant="caption" 
          sx={{ 
            display: 'block', 
            mb: 1.5, 
            fontWeight: 600,
            color: 'text.secondary',
            textTransform: 'uppercase',
            letterSpacing: 0.5,
          }}
        >
          Tu Respuesta
        </Typography>
        {/* Campo de texto */}
        <TextField
          fullWidth
          multiline
          rows={4}
          value={texto}
          onChange={handleChange}
          placeholder="Escribe tu respuesta aquí..."
          variant="outlined"
          name={`pregunta-${pregunta.id}`}
          id={`pregunta-texto-${pregunta.id}`}
          inputProps={{
            maxLength,
            name: `pregunta-${pregunta.id}`,
          }}
          InputProps={{
            name: `pregunta-${pregunta.id}`,
          }}
          helperText={
            minLength > 0
              ? `Mínimo ${minLength} caracteres. ${texto.length}/${maxLength}`
              : `${texto.length}/${maxLength} caracteres`
          }
          error={minLength > 0 && texto.length > 0 && texto.length < minLength}
          sx={{
            '& .MuiOutlinedInput-root': {
              bgcolor: 'background.paper',
              fontSize: { xs: '0.875rem', sm: '0.9375rem' },
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default QuestionTexto;
